<template>
  <v-card flat>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subtitle-1">{{ $t("pageHeader.batchList") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title class="mt-0">
      <v-flex xs12 sm4="sm4">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line="single-line" hide-details
          clearable="clearable">
        </v-text-field>
      </v-flex>
    </v-card-title>
    <v-card-text>
      <v-data-table :headers="headers" :items="batchs" :loading="loading" :search="search" :sort-by="sortBy"
        :page.sync="page" :items-per-page="itemsPerPage">
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-left" @click="openBatch(props.item.id)">
              {{ $moment(props.item.createdAt).format("MM/DD/YYYY") }}
            </td>
            <td class="text-left" @click="openBatch(props.item.id)">
              {{ props.item.Store.CSPID }}
            </td>
            <td class="text-left" @click="openBatch(props.item.id)">
              {{ props.item.Store.businessName }}
            </td>
            <td class="text-left" @click="openBatch(props.item.id)">
              {{ props.item.Store.businessPhone }}
            </td>
            <td class="text-left" @click="openBatch(props.item.id)">
              {{ props.item.emailSubject }}
            </td>
            <td>
              <v-btn color="info" rounded @click="emailReport(props.item)">Email</v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import batchService from "@/pages/Batch/service.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "batch-list",
  data() {
    return {
      dialog: false,
      terminalURL: process.env.VUE_APP_TERMINALURL,
      sortBy: "createdAt",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: this.$t("labels.date"),
          align: "left",
          sortable: true,
          value: "createdAt",
          width: "10%"
        },
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true
        },
        {
          text: this.$t("labels.name"),
          value: "Store.businessName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "Store.businessPhone",
          sortable: true
        },
        {
          text: this.$t("labels.subject"),
          value: "emailSubject",
          sortable: true
        },
        {
          text: "Action",
          value: "",
          sortable: false
        }
      ],
      search: null,
      batchs: [],
      loading: true
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"])
  },
  methods: {
    async emailReport() {
      const { value: text } = await this.$swal.fire({
        title: "Email Address",
        input: "email",
        showCancelButton: true
      });
      if (text) {
        let data = {
          toEmail: text,
          cspId: this.batch.Store.CSPID,
          subject: this.batch.emailSubject,
          body: this.batch.emailBody,
          businessName: this.batch.Store.businessName,
          mailType: "HTML"
        };
        // console.log('email', text, this.batch)
        return batchService
          .sendEmail(data)
          .then(result => {
            console.log("email result", result);
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Email was send successfully."
              });
            // this.loadOrganization()
          })
          .catch(err => {
            this.$swal({
              title: `Batch Email`,
              text: `Can't send email`,
              type: "error"
            });
          });
      }
    },
    getList() {
      console.log("test", this.currentOrganization.organizationID);
      return batchService.getAll(this.currentOrganization.organizationID).then(response => {
        console.log("response", response);
        this.batchs = response.data;
        this.loading = false;
        return response;
      });
    },
    openBatch(id) {
      this.$router.push({ path: `/batch/view/${id}` });
    }
  }
};
</script>
